import { Link as RouterLink } from "react-router-dom";
import type { AnchorHTMLAttributes, ReactNode } from "react";

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children?: ReactNode;
}

// Drop-in replacement for `next/link`: internal paths use the client-side
// router, external/protocol links (and #anchors) fall back to a plain <a>.
const isExternal = (href: string) => /^(https?:|mailto:|tel:|#)/.test(href);

export default function Link({ href, children, target, rel, ...rest }: LinkProps) {
  if (isExternal(href)) {
    const external = href.startsWith("http");
    return (
      <a
        href={href}
        target={target ?? (external ? "_blank" : undefined)}
        rel={rel ?? (external ? "noopener noreferrer" : undefined)}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={href} {...rest}>
      {children}
    </RouterLink>
  );
}
